export default __webpack_public_path__ + "static/media/nautilus6.13edab1a.jpg";